@if (sports.length === 0 && !($loading | async)) {
  <app-alert
    [config]="{
      title: 'No Sports Listings',
      subtitle: 'Check back later for updated sports events.',
      type: 'info',
    }" />
}
<app-sports-loader [show]="$loading | async" />
@if (sports.length > 0) {
  <ul class="markets-list list-unstyled">
    @for (item of sports; track item) {
      <li>
        <a
          [routerLink]="[
            '/app/main',
            {
              outlets: {
                navigation: [item.type.toLowerCase(), item.id],
              },
            },
          ]"
          class="nav-link">
          {{ item?.name }}
        </a>
      </li>
    }
  </ul>
}
